import {Validators} from '@angular/forms';

import {TradingAccountStatusesEnum} from '@spa/api';

import {ColorCodesEnum, ComponentTypesEnum} from '../../../app/shared/enums';
import {BaseControl, Helper, RadioGroupControl} from '../../../app/shared/classes';
import {DialogButtonTypesEnum, DialogConfigInterface, RadioGroupOptionInterface} from '../../../app/shared/components';

import {ChangeTradingAccountStatusMessages} from '../../messages';

export const ChangeTradingAccountStatusSelector = 'status';
export const ChangeTradingAccountStatusMessageSelector = 'message';

export const ChangeTradingAccountStatusControls = (): BaseControl[] => {
    return [
        new RadioGroupControl({
            name: ChangeTradingAccountStatusSelector,
            value: null,
            placeholder: 'Status',
            validators: [
                Validators.required
            ],
            componentType: ComponentTypesEnum.RadioGroup,
            invalid: false,
            errors: [],
            options: []
        }),
        new BaseControl({
            name: ChangeTradingAccountStatusMessageSelector,
            value: null,
            placeholder: 'Message',
            validators: [],
            componentType: ComponentTypesEnum.Text
        })
    ];
};

export const ChangeTradingAccountStatusOptions = (): RadioGroupOptionInterface[] => {
    return [
        {
            label: Helper.textsHelper().getTradingAccountStatusName(TradingAccountStatusesEnum.ForApproval),
            value: TradingAccountStatusesEnum.ForApproval,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingAccountStatusName(TradingAccountStatusesEnum.Rejected),
            value: TradingAccountStatusesEnum.Rejected,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingAccountStatusName(TradingAccountStatusesEnum.Active),
            value: TradingAccountStatusesEnum.Active,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingAccountStatusName(TradingAccountStatusesEnum.WithdrawalRestricted),
            value: TradingAccountStatusesEnum.WithdrawalRestricted,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingAccountStatusName(TradingAccountStatusesEnum.Blocked),
            value: TradingAccountStatusesEnum.Blocked,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingAccountStatusName(TradingAccountStatusesEnum.BlockOrderEntry),
            value: TradingAccountStatusesEnum.BlockOrderEntry,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingAccountStatusName(TradingAccountStatusesEnum.BlockShortSells),
            value: TradingAccountStatusesEnum.BlockShortSells,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingAccountStatusName(TradingAccountStatusesEnum.Closed),
            value: TradingAccountStatusesEnum.Closed,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getTradingAccountStatusName(TradingAccountStatusesEnum.ClosedCancel),
            value: TradingAccountStatusesEnum.ClosedCancel,
            color: ColorCodesEnum.Primary
        }
    ];
};

export const ChangeTradingCashAccountStatusOptions = (): RadioGroupOptionInterface[] => {
    return [
        {
            label: Helper.textsHelper().getCashAccountStatusName(TradingAccountStatusesEnum.ForApproval),
            value: TradingAccountStatusesEnum.ForApproval,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getCashAccountStatusName(TradingAccountStatusesEnum.Rejected),
            value: TradingAccountStatusesEnum.Rejected,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getCashAccountStatusName(TradingAccountStatusesEnum.Active),
            value: TradingAccountStatusesEnum.Active,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getCashAccountStatusName(TradingAccountStatusesEnum.WithdrawalRestricted),
            value: TradingAccountStatusesEnum.WithdrawalRestricted,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getCashAccountStatusName(TradingAccountStatusesEnum.Blocked),
            value: TradingAccountStatusesEnum.Blocked,
            color: ColorCodesEnum.Primary
        },
        {
            label: Helper.textsHelper().getCashAccountStatusName(TradingAccountStatusesEnum.Closed),
            value: TradingAccountStatusesEnum.Closed,
            color: ColorCodesEnum.Primary
        },
    ];
};

export const ChangeTradingStatusDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: ChangeTradingAccountStatusMessages.UpdateAccountStatusFailed.message,
            succeedMessage: ChangeTradingAccountStatusMessages.UpdateAccountStatusSucceeded.message
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Save
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};
